import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '@/common/stripe/stripeClient';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { usePlanPaymentIntent } from '../../hooks/usePlanPaymentIntent';
import PaymentElementField from './PaymentElementField';
import PlanPaymentForm from './PlanPaymentForm';
import { BackButton, ErrorMessage } from './PlanPayment.styles';

const PlanPaymentElements = ({
	selectedPlan,
	createPayment,
	onConfirmError,
	...formProps
}) => {
	const t = useLanguageData('chat');
	const { user } = useGuestAuth();
	const { intent, options, isError, lastErrorMessage, retry } =
		usePlanPaymentIntent({
			selectedPlan,
			user,
			createPayment,
		});

	const handleConfirmError = (error) => {
		onConfirmError?.(error);
		retry(error.message);
	};

	if (isError) {
		return (
			<>
				<ErrorMessage>{t.planCheckoutPaymentError}</ErrorMessage>
				<BackButton type='button' onClick={() => retry()}>
					{t.planCheckoutRetry}
				</BackButton>
			</>
		);
	}

	if (!options) {
		return <PaymentElementField isReady={false} />;
	}

	return (
		<Elements
			key={options.clientSecret}
			stripe={stripePromise}
			options={options}
		>
			<PlanPaymentForm
				intent={intent}
				selectedPlan={selectedPlan}
				initialErrorMessage={lastErrorMessage}
				onConfirmError={handleConfirmError}
				{...formProps}
			/>
		</Elements>
	);
};

export default PlanPaymentElements;
